// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___3VUzZ","contentWrapper":"contentWrapper___3pVOT","text":"text___Lmi48","bttn":"bttn___1CqAl"};